import React, {useContext, useState} from 'react'
import {useHttp} from '../hooks/http.hook'
import {AuthContext} from '../context/AuthContext'
import {objectLang, returnToPage, setErrorWindow, setLocalStorageItem, validationEmail} from "../functions"
import {ModalWin} from "../elements/ModalWin"
import {LoaderClass} from "../elements/LoaderClass"
import {UpdateUserClass} from "../elements/UpdateUserClass"
import config from "../config.json"

export const UpdateUserPage = () => {
    setLocalStorageItem('page', 'UpdateUserPage')

    const auth = useContext(AuthContext)

    const {request, loading} = useHttp()
    let lang = objectLang().language
    const l = lang.lang
    const [allowed, setAllowed] = useState(true)
    const [dataModal, setDataModal] = useState({})
    const [user, setUser] = useState(null)
    const [content, setContent] = useState({folders: [], links: [], notes: []})
    let host
    window.location.host === 'localhost:3000' ? host = config.localHost : host = config.onrender

    if (!auth.superUser) {
        returnToPage('MainPage')
        // window.location.replace(`/${l}/`)
    }

    const sendEmail = async email => {
        const validEmail = validationEmail(email)
        if (!validEmail.flag) {
            setAllowed(false)
            setDataModal(setErrorWindow(
                '',
                0,
                lang.messages[`code_${validEmail.code}`])
            )
            return
        }
        const encodedEmail = btoa(email.toLowerCase())
        try {
            const fetch = await request(
                `${host}/api/super-user/get-user`,
                'POST',
                {
                    email: encodedEmail
                })

            if (fetch.status > 200) {
                setAllowed(false)
                setDataModal(setErrorWindow(
                    '',
                    fetch.data.code,
                    lang.messages[`code_${fetch.data.code}`],
                    '',
                    `replaceTo /${l}/admin/update-user`,
                    '',
                    `replaceTo /${l}/admin/update-user`
                ))
            } else {
                // console.log(fetch)
                setUser(fetch.user)
                const content = {
                    folders: fetch['allFolders'],
                    links: fetch['allLinks'],
                    notes: fetch['allNotes'],
                }
                setContent(content)
            }

        } catch (e) {
            window.location.replace(`/${l}/admin/update-user`)
        }
    }

    if (loading) {
        return <LoaderClass/>
    }

    if (!allowed) {
        return (
            <>
                {<ModalWin data={dataModal}/>}
            </>

        )
    }

    return (
        <>
            <UpdateUserClass
                user={user}
                content={content}
                lang={lang}
                sendEmail={sendEmail}
            />
        </>
    )
}
